module.exports = __webpack_public_path__ + "img/rtl2-spot.9d91e214.jpg";